import { lazy } from 'react';

const Popup = lazy(() => import('./Popup'));
const PopupContent = lazy(() => import('./PopupContent'));
const Popups = lazy(() => import('./Popups'));

const PopupsAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/popups/:popupUid/content',
			element: <PopupContent />
		},
		{
			path: '/apps/popups/:popupUid',
			element: <Popup />
		},
		{
			path: '/apps/popups',
			element: <Popups />
		}
	]
};

export default PopupsAppConfig;
